import React from 'react';
import { Button } from './ui/Button';
import { Sparkles } from 'lucide-react';
export function CallToAction() {
  return <section className="py-24 bg-gradient-to-br from-red-900 via-red-800 to-red-900 relative overflow-hidden" data-id="element-12">
      {/* Texture overlay */}
      <div className="absolute inset-0 opacity-20 bg-[url('https://www.transparenttextures.com/patterns/cubes.png')]" data-id="element-13"></div>

      <div className="container mx-auto px-4 text-center relative z-10" data-id="element-14">
        <div className="inline-block p-3 rounded-full bg-white/10 backdrop-blur-sm mb-8 animate-bounce" data-id="element-15">
          <Sparkles className="w-8 h-8 text-amber-400" data-id="element-16" />
        </div>

        <h2 className="text-4xl md:text-6xl font-serif font-bold text-white mb-6" data-id="element-17">
          Transformá tus clases con el <br data-id="element-18" />
          <span className="text-amber-400" data-id="element-19">Mega Pack de Teatro</span>
        </h2>

        <p className="text-xl text-red-100 max-w-2xl mx-auto mb-10" data-id="element-20">
          Accedé hoy mismo a cientos de recursos, planificaciones y dinámicas.
          Empezá a disfrutar más de tu tiempo libre.
        </p>

        <div className="flex flex-col sm:flex-row justify-center gap-4" data-id="element-21">
          <a href="https://checkout.digitalpack.shop/cart/43448261443662:1" target="_blank" rel="noopener noreferrer" data-id="element-22">
            <Button size="lg" variant="secondary" className="text-xl px-10 py-6 shadow-2xl shadow-amber-900/50 hover:scale-105 transform transition-all" data-id="element-23">
              ¡Quiero el Mega Pack Ahora!
            </Button>
          </a>
        </div>

        <p className="mt-6 text-sm text-red-200 opacity-80" data-id="element-24">
          Acceso inmediato • Pago seguro • Garantía de satisfacción
        </p>
      </div>
    </section>;
}